// fetch() que aguenta a API sumir por alguns segundos — pedido 2026-10-01
// ("failed to fetch ... isso nunca pode acontecer"). Causa real achada nos
// logs do Nginx: a cada deploy o container do backend (e, mais raro, o
// Traccar) reinicia e fica ~5-10s sem aceitar conexão; o Nginx devolve 502
// SEM cabeçalho CORS (inclusive no preflight OPTIONS), e o navegador só
// mostra "TypeError: Failed to fetch". Quem estava salvando um usuário
// naquele instante via o erro na cara (ex.: 30/09 19:14, edição do usuário
// 1314).
//
// Só repete quando o fetch nem chegou a ter resposta (TypeError de rede) —
// nesse caso a requisição não foi processada (conexão recusada/preflight
// falhou), então repetir é seguro mesmo para POST/PUT. Qualquer resposta
// HTTP de verdade (4xx/5xx legíveis) volta na hora, sem repetir.
// Cancelamento (AbortController) nunca é repetido.
//
// 429 (limite de requisições do backend, 2026-10-01) também é repetido: o
// backend recusa ANTES de processar, então repetir um PUT/POST é seguro —
// antes o "Salvar" de veículo/usuário levava 429 e simplesmente não gravava.
const RETRY_DELAYS_MS = [1000, 2000, 3000, 4000, 5000];
const RATE_LIMIT_RETRIES = 3;

export async function fetchWithNetworkRetry(
  input: string,
  init: RequestInit,
): Promise<Response> {
  let rateLimitAttempt = 0;
  for (let attempt = 0; ; attempt++) {
    try {
      const res = await fetch(input, init);
      if (res.status === 429 && rateLimitAttempt < RATE_LIMIT_RETRIES && !init.signal?.aborted) {
        rateLimitAttempt++;
        const retryAfterSec = Number(res.headers.get("retry-after"));
        const waitMs =
          Number.isFinite(retryAfterSec) && retryAfterSec > 0
            ? Math.min(retryAfterSec * 1000, 10_000)
            : rateLimitAttempt * 2000;
        await new Promise((r) => setTimeout(r, waitMs));
        attempt--;
        continue;
      }
      return res;
    } catch (err) {
      const aborted =
        init.signal?.aborted || (err instanceof DOMException && err.name === "AbortError");
      if (aborted || !(err instanceof TypeError)) throw err;
      if (attempt >= RETRY_DELAYS_MS.length) {
        // 2026-10-02: o operador via "Não foi salvo: Failed to fetch" (texto
        // cru do navegador). Continua TypeError pra quem checa o tipo.
        throw new TypeError(
          "Sem conexão com o servidor. Verifique a internet, recarregue a página (F5) e tente de novo.",
        );
      }
      await new Promise((r) => setTimeout(r, RETRY_DELAYS_MS[attempt]));
    }
  }
}
